import PropTypes from 'prop-types';
import React from 'react';

import style from './style.module.scss';

const propTypes = {
  show: PropTypes.bool,
};

const TableLoading = ({ show }) => (show ? <tr className={style.tableInfinityLoader} /> : null);

TableLoading.propTypes = propTypes;

export default TableLoading;
